import { api } from "../../../api/apiSlice";

// Not a normal master - one fixed config (Tax_id=1) with N slab rows keyed
// by slNo. Slabs are CRUD'd one at a time (PUT upserts by slNo, null =
// new row) - unlike Deductions there's no full-list diff endpoint.
export const taxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTaxSlabs: builder.query({
      query: () => ({ url: "/masters/tax" }),
      providesTags: ["HrTax"],
    }),
    saveTaxSlab: builder.mutation({
      query: (body) => ({ url: "/masters/tax/slabs", method: "PUT", data: body }),
      invalidatesTags: ["HrTax"],
    }),
    deleteTaxSlab: builder.mutation({
      query: (slNo) => ({ url: `/masters/tax/slabs/${slNo}`, method: "DELETE" }),
      invalidatesTags: ["HrTax"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetTaxSlabsQuery, useSaveTaxSlabMutation, useDeleteTaxSlabMutation } = taxApi;
